// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__281I8","signatureBlock":"Footer_signatureBlock__169k4","signature":"Footer_signature__2f2E5"};